import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { ClinicSubscriptionsApi } from '../../../apis/ClinicSubscriptionsApi/ClinicSubscriptionsApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useTranslation } from 'react-i18next';

export function useDeleteClinicSubscription() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation({
        mutationFn: async (subscriptionId: string) => {
            return await ClinicSubscriptionsApi.deleteSubscription(subscriptionId);
        },
        onSuccess: () => {
            // Invalidate clinic seat usage related queries
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicSeatUsage] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.healthcareFacility] });
            // Also invalidate the all clinic seat usages query
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicSeatUsage, 'all'] });
            notifications.show({
                title: t('clinicSubscriptions.success.deleteTitle'),
                message: t('clinicSubscriptions.success.deleteMessage'),
                color: 'green',
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('clinicSubscriptions.errors.deleteErrorTitle'),
                message: error?.response?.data?.error || t('clinicSubscriptions.errors.deleteError'),
                color: 'red',
            });
        },
    });
}

